import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import localforage from 'localforage';
import app from "./app/Reducers";
import queueReducer from "./offline/QueueReducer";
import cacheReducer from "./offline/CacheReducer";

const appConfig = {
  key: "app",
  storage: localforage,
  timeout: 60000
}

const queueConfig = {
  key: "queue",
  storage: localforage,
  timeout: 60000
}

const cacheConfig = {
  key: "cache",
  storage: localforage,
  timeout: 60000
}

export const Reducers = combineReducers({
  app: persistReducer(appConfig, app),
  queue: persistReducer(queueConfig, queueReducer),
  cache: persistReducer(cacheConfig, cacheReducer),
})
